// extracted by mini-css-extract-plugin
module.exports = {"controls":"CommentEdit_controls__1BwBd","field":"CommentEdit_field__3aOHr"};